import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { InputComponent } from '../input/input.component';
import { CommonService } from '../../services/common.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-resend-verification-email',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule, ButtonComponent, InputComponent, TranslateModule],
  templateUrl: './resend-verification-email.component.html',
  styleUrl: './resend-verification-email.component.scss'
})
export class ResendVerificationEmailComponent {
  verificateEmailForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  isLoading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private authService: AuthService,
    private commonService: CommonService
  ) {
  }

  onSubmit() {
    this.verificateEmailForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.verificateEmailForm)
    if (this.verificateEmailForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';
      const { email } = this.verificateEmailForm.value;
      if(!email) return
      this.authService.resendVerification(email).subscribe(
        (response) => {
          this.isLoading = false;
          this.successMessage = response.message ?? 'Se han enviado las instrucciones a tu correo electrónico. Si no ves el correo, revisa la carpeta de spam';
        },
        (error) => {
          console.error('Error al solicitar recuperación de contraseña:', error);
          this.isLoading = false;
          this.errorMessage = error.error.message ?? 'Error al procesar la solicitud. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }
}
